import { render, staticRenderFns } from "./TravelPackageComponent.vue?vue&type=template&id=43d57a5f&scoped=true"
import script from "./TravelPackageComponent.vue?vue&type=script&lang=js"
export * from "./TravelPackageComponent.vue?vue&type=script&lang=js"
import style0 from "./TravelPackageComponent.vue?vue&type=style&index=0&id=43d57a5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d57a5f",
  null
  
)

export default component.exports